// extracted by mini-css-extract-plugin
export default {"body":"AdminWithdrawal_body__RNJEA","title":"AdminWithdrawal_title__O2GV6"};